import clx from 'classnames';
import { easeInOut, motion } from 'motion/react';

type Props = {
  className?: string;
};

const TitleUnderline = ({ className }: Props) => (
  <motion.hr
    animate={{ width: '100%' }}
    className={clx(className, 'border-none bg-gradient-to-r from-transparent to-transparent via-primary-400 h-1')}
    initial={{ width: 0 }}
    transition={{ duration: 0.3, ease: easeInOut, delay: 1 }}
  />
);

export default TitleUnderline;
